import Rating from "./Rating";

type Props = {
  userCbtSoftSkill: any;
};

const HrResults = ({ userCbtSoftSkill }: Props) => {

  return (
    <div className="overflow-x-auto w-full">
      <h2 className="font-display text-base lg:text-2xl font-semibold mb-2">
        Vetted Soft Skills
      </h2>

      <div className="text-sm md:text-base grid grid-cols-1 md:grid-cols-2 gap-3 w-full">
        <div className="flex space-x-2 items-center">
          <p>Communication: </p>
          <Rating rating={userCbtSoftSkill?.communication ?? 0} />
        </div>
        <div className="flex space-x-2 items-center">
          <p>Productivity: </p>
          <Rating rating={userCbtSoftSkill?.productivity ?? 0} />
        </div>
        <div className="flex space-x-2 items-center">
          <p>Motivation: </p>
          <Rating rating={userCbtSoftSkill?.motivation ?? 0} />
        </div>
        <div className="flex space-x-2 items-center">
          <p>Learning Velocity: </p>
          <Rating rating={userCbtSoftSkill?.learning_velocity ?? 0} />
        </div>
        <div className="flex space-x-2 items-center">
          <p>Consistency: </p>
          <Rating rating={userCbtSoftSkill?.consistency_reliability ?? 0} />
        </div>
        <div className="flex space-x-2 items-center">
          <p>Self-driven: </p>
          <Rating rating={userCbtSoftSkill?.self_driven ?? 0} />
        </div>
        <div className="flex space-x-2 items-center">
          <p>Leadership: </p>
          <Rating rating={userCbtSoftSkill?.leadership ?? 0} />
        </div>
        <div className="flex space-x-2 items-center">
          <p>Creativity: </p>
          <Rating rating={userCbtSoftSkill?.creativity ?? 0} />
        </div>
        <div className="flex space-x-2 items-center">
          <p>Value alignment: </p>
          <Rating rating={userCbtSoftSkill?.value_alignment ?? 0} />
        </div>
        <div className="flex space-x-2 items-center">
          <p>Depth of past work: </p>
          <Rating rating={userCbtSoftSkill?.depth_of_past_work ?? 0} />
        </div>
      </div>
    </div>
  );
};

export default HrResults;
